export default __webpack_public_path__ + "static/media/screen6.dc2b622d.png";